import React, { useEffect, useState } from 'react';
import { Button, Icon, useTranslation } from '@testsigma/atoms';
import {
  MetadataConnectionModalScreens,
  UserConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

interface TestConnectionSuccessModalProps {
  isUserConnection: boolean;
}
export const TestConnectionSuccessModal: React.FC<TestConnectionSuccessModalProps> = ({isUserConnection}) => {
  const { handleUpdateMetadataConnectionModalScreen, handleUpdateUserConnectionModalScreen } = useSFConnectionState();
  const { t } = useTranslation();

  const handleGoBack = () => {
    isUserConnection? handleUpdateUserConnectionModalScreen(UserConnectionModalScreens.CONNECTION_CREATE_SCREEN):handleUpdateMetadataConnectionModalScreen(
      MetadataConnectionModalScreens.CONNECTION_CREATE_SCREEN,
    );
  };

  return (
    <>
      <div className='h-full pt-6 pb-8 px-6'>
        <div className='mt-4'>
          <div className='w-12 h-12 bg-primary-50 rounded-full flex items-center justify-center'>
            <div className='w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center'>
              <Icon name='check-circle-outline' className='text-primary-600 text-xl'></Icon>
            </div>
          </div>
        </div>

        <div className='mt-6'>
          <h3 className='text-xl font-semibold text-secondary-text'>
            {t('salesforce_connection_success')}
          </h3>

          <div className='mt-4'>
            <div className='text-secondary-800 text-base font-medium'>
              {t('salesforce_connection_status')}
            </div>
            <p className='text-secondary-500 text-sm mt-1'>
              {t('test_connection_success_message')}
            </p>
          </div>

          <div className='mt-4'>
            <div className='text-secondary-800 text-base font-medium'>
              {t('salesforce_next_steps')}
            </div>
            <p className='text-secondary-500 text-sm mt-1'>
              {t('salesforce_next_steps_message')}
            </p>
          </div>

          <Button type='secondary' className='mt-6' onClick={handleGoBack}>
            {t('salesforce_connections_go_back')}
          </Button>
        </div>
      </div>
    </>
  );
};
